import { useEffect } from "react";
import type { anesthIntroduceEditorTemplateSelectorQuery$data as QueryType } from './__generated__/anesthIntroduceEditorTemplateSelectorQuery.graphql'



export default function TemplateSelector(props: { templateData: QueryType, onSelect: (content: string) => void }) {

    useEffect(() => {
        console.log('load');
        console.log(props.templateData);
    }, []);


    const confirmSelect = (contenthtml: string) => {
        props.onSelect(contenthtml);
    };


    return (
        <>
            <div style={{"maxHeight": '80vh', "overflowY": 'auto'}}>
                {
                    props.templateData.grapes_template_connection.edges.map((template) => {
                        return (
                            <div className="grid sm:grid-cols-6 grid-cols-1 gap-x-6 gap-y-8 mx-4 my-10">
                                <img className="sm:col-span-3" src={template.node.imageurl} alt={template.node.name} />
                                <div className="sm:col-span-3">
                                    <h3 className="text-xl">{template.node.name}</h3>
                                    <p className="text-sm">{template.node.description}</p>
                                    <button
                                        type="button"
                                        onClick={() => confirmSelect(template.node.contenthtml)}
                                        className="rounded-md bg-indigo-600 px-3.5 py-2.5 mt-4 text-base font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        插入此樣板
                                    </button>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </>
    );
}